// extracted by css-extract-rspack-plugin
export default {"cls1":"PackPreviewRows-cls1_d-S","cls2":"PackPreviewRows-cls2_VCB PackPreviewRows-cls1_d-S"};